// extracted by mini-css-extract-plugin
export default {"triangle-heart":"RHPXTSv7dzyUBHndHypJ","img-div":"BA3PrwK7LnBGLObcV3Aa","type-default":"zc3kj4MhMNlWaSU96iXA","common_bganimation":"kHYJt0l6IL_pTj2ClrT5"};